import { forwardRef } from 'react';
import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  leftIcon?: ReactNode;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, leftIcon, hint, className = '', id, ...props }, ref) => (
    <div className="w-full">
      {label && <label htmlFor={id} className="input-label">{label}</label>}
      <div className="relative">
        {leftIcon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-300 pointer-events-none">
            {leftIcon}
          </span>
        )}
        <input
          ref={ref}
          id={id}
          className={`input ${leftIcon ? 'pl-10' : ''} ${className}`}
          {...props}
        />
      </div>
      {hint && <p className="mt-1 text-xs text-ink-500">{hint}</p>}
    </div>
  )
);
Input.displayName = 'Input';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, className = '', id, children, ...props }, ref) => (
    <div className="w-full">
      {label && <label htmlFor={id} className="input-label">{label}</label>}
      <select ref={ref} id={id} className={`input cursor-pointer ${className}`} {...props}>
        {children}
      </select>
    </div>
  )
);
Select.displayName = 'Select';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, className = '', id, ...props }, ref) => (
    <div className="w-full">
      {label && <label htmlFor={id} className="input-label">{label}</label>}
      <textarea
        ref={ref}
        id={id}
        className={`input min-h-20 py-2 resize-y ${className}`}
        {...props}
      />
    </div>
  )
);
Textarea.displayName = 'Textarea';
